export function exposeToWindow<T extends object>(obj: T, { overwrite = false }: { overwrite?: boolean } = {}): T {
  if (typeof window === 'undefined') return obj
  for (const key of Object.keys(obj) as (keyof T)[]) {
    if (overwrite || !(key in window)) {
      Object.defineProperty(window, key, {
        get: () => (obj as any)[key],
        set: v => ((obj as any)[key] = v),
        configurable: true,
        enumerable: true
      })
    }
  }

  return new Proxy(obj, {
    defineProperty(target, prop, descriptor) {
      const ok = Reflect.defineProperty(target, prop, descriptor)
      if (ok) {
        Object.defineProperty(window as any, prop, {
          get: () => (target as any)[prop],
          set: v => ((target as any)[prop] = v),
          configurable: true,
          enumerable: true
        })
      }
      return ok
    },
    set(target, prop, value, receiver) {
      const ok = Reflect.set(target, prop, value, receiver)
      Object.defineProperty(window as any, prop, {
        get: () => (target as any)[prop],
        set: v => ((target as any)[prop] = v),
        configurable: true,
        enumerable: true
      })
      return ok
    }
  })
}
